import { LogoRenessans } from '@lt/components/icons-react/userflow/package';
import { useTranslation } from '@lt/localization';
import React from 'react';

import ExtraItem from './components/ExtraItem';

import type { PropsFromRedux } from '.';
import { InsuranceDescription } from './components/InsuranceDescription';
import styles from './extraInsurance.module.css';

export const ExtraInsurance = (
  props: PropsFromRedux & { className?: string },
): JSX.Element | null => {
  const {
    insurance,
    isTouristsSkipDoc,
    className = '',
    toggleInsurance,
    isSelectedInsurance,
  } = props;
  const { t } = useTranslation();

  if (!insurance) return null;
  const {
    options: [{ price, description }],
    title,
    tooltip,
  } = insurance;

  return (
    <div className={`checkout-service-block ${className}`}>
      <h2 className="like-h2">{t('checkout.services.cancellationPolicy')}</h2>

      <ul>
        <ExtraItem
          selected={isSelectedInsurance}
          price={Number(price)}
          hashsum="renins_cancellation"
          name={title || ''}
          onChange={() => toggleInsurance()}
          description={
            <InsuranceDescription
              tooltip={tooltip || ''}
              description={description}
            />
          }
        >
          <div className={styles.title}>
            <LogoRenessans width={200} />
          </div>

          {isSelectedInsurance && isTouristsSkipDoc && (
            <div className={styles.danger}>
              {t('checkout.services.insuranceWithoutDocs')}
            </div>
          )}
        </ExtraItem>
      </ul>
    </div>
  );
};
